import { useContext } from "react";
import { StreamContext } from "../contexts/StreamContext";

export const useStream = () => {
    const { commentStream, audioStream, stream } = useContext(StreamContext);
    return { commentStream, audioStream ,stream};
}

export const useStreamContext = () => useContext(StreamContext);
